<div class="dashboard__content">
    <div class="card mt-1">
        <div class="card-body p-4">
            <div class="justify-content-end">
                <div class="d-flex flex-row justify-content-end align-items-center">
                <div>
                    <select class="form-select" aria-label="Default select example"
                        (change)="onClickVendorName($event)">
                        <option selected disabled>Please, Select Status</option>
                        <option value="name" [value]="vendor.name" *ngFor="let vendor of vendorName">
                            {{vendor.name}}</option>
                    </select>
                </div>
                <button class="btn btn-outline-primary m-2" [disabled]="!selectedStatus" (click)="clearThePr()">
                    Clear PR
                </button>
                <a type="button" class="btn btn-primary text-white me-2" (click)="convertToPR()">
                    Process To PR
                </a>
            </div>
            <app-ag-grid-wrapper #grid [gridConfig]='gridOptions' [rowData]="purchaseRequests" [columnDefs]="columnDefs"
                (rowSelected)="onRowSelect($event)" [frameworkComponents]='frameworkComponents' [context]='context'
                (gridReady)="onGridReady($event)">
            </app-ag-grid-wrapper>
        </div>
    </div>
</div>